import React from 'react';
import styles from './styles.scss';

function Fold({ children, bgStyle, top }) {
  return (
    <div
      className={`${styles.aboveTheFold} above-the-fold`}
      style={{paddingTop: top, background: bgStyle}}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-10 col-sm-12 col-lg-10 col-center">
            <div className="text-left mt80">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Fold;



// WEBPACK FOOTER //
// ./src/components/Fold/index.js